import utils from "../../../business/helper/Utils";
import icon from "../../../images/logo.svg";
import like from "../../../images/icons/like.svg";
import dislike from "../../../images/icons/dislike.svg";
import comment from "../../../images/icons/comment.svg";
import pdf from "../../../images/icons/pdf.svg";
import xls from "../../../images/icons/xls.svg";
import copy from "../../../images/icons/copy.svg";
import schedule from "../../../images/icons/schedule.svg";
import clsx from "clsx";
import "katex/dist/katex.min.css";
import { useMemo } from "react";
import Lottie from "lottie-react";
import milaLoader from "../../../images/animations/mila-loader.json";
import React from "react";
import useTypingEffect from "../../../hooks/useTypingEffect";

const TypingMessage = React.memo(({ processingMessage }) => {
  const { displayed, isDone } = useTypingEffect(processingMessage, 18);

  return (
    <>
      <div
        className="leading-8 text-violet-100 font-notosans text-[14px]"
        style={{ marginTop: "-0.5px" }}
      >
        {displayed}
        {isDone && (
          <>
            &nbsp;<span className="loaderChat"></span>
          </>
        )}
      </div>

      <div className="h-4" />
    </>
  );
});

const Response = ({
  isLastItem = false,
  isLoading,
  loadingExcel,
  conv,
  favorites,
  onFavoriteClick,
  onCopyClick,
  onLikeClick,
  showCommentModal,
  exportPdf,
  exportExcel,
  onScheduleClick,
  scheduleDisabled = false,
  children,
  charts,
  tables,
  threadId,
  processingMessage,
  hideActions = false,
}) => {

  const isFavorite = useMemo(() => {
    if (!favorites?.length) return false;

    if (conv?.uploadedFiles?.length > 0) {
      return favorites.some((favorite) =>
        favorite.title.includes(conv.uploadedFiles[0].file_name)
      );
    }

    return favorites.some(
      (favorite) => favorite.title === conv.question
    );
  }, [favorites, conv]);

  const renderedReports = useMemo(() => {
    return utils.renderWithReports(
      children,
      charts,
      tables,
      threadId
    );
  }, [children, charts, tables, threadId]);

  return (
    <div
      className={clsx("flex items-start pt-4 pb-7 gap-3 lg:gap-3 font-emoji", {
        "flex-col": conv.date !== undefined,
      })}
    >
      {conv.date === undefined ? (
        <>
          {!(isLoading && isLastItem) && (
            <img
              key={"mila_avatar"}
              src={icon}
              alt="Mila Avatar"
            />
          )}

          {isLoading && isLastItem && (
            <Lottie
              animationData={milaLoader}
              loop={true}
              autoplay={true}
              style={{
                width: "32px",
                height: "32px",
                minWidth: "32px",
                minHeight: "32px"
              }}
            />
          )}
        </>
      ) : (
        <div
          className={
            conv.date !== undefined && "flex w-full items-center gap-6"
          }
        >
          {!(isLoading && isLastItem) && (
            <img
              key={"mila_avatar"}
              src={icon}
              alt="Mila Avatar"
            />
          )}

          {isLoading && isLastItem && (
            <Lottie
              animationData={milaLoader}
              loop={true}
              autoplay={true}
              style={{
                width: "32px",
                height: "32px",
                minWidth: "32px",
                minHeight: "32px"
              }}
            />
          )}

          <div className="relative w-full h-px bg-pink">
            <div className="absolute left-1/2 -translate-y-1/2 -translate-x-1/2 px-5 bg-white">
              <div className="rounded px-3 py-0.5 text-dimgray-200 text-xs bg-pink-100">
                {conv.date}
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className={clsx("text-[14px]", {
          "ml-12": conv.date !== undefined
        })}
        style={{ maxWidth: "815px" }}
      >
        {isLoading && !processingMessage && conv.isOnboarding !== true && (
          <p
            className="leading-8 text-violet-100 font-notosans"
            style={{ marginTop: "-3px" }}
          >
            Hold on while I look up the best answer for you.
          </p>
        )}

        {isLoading &&
          processingMessage &&
          isLastItem && (
            <TypingMessage
              processingMessage={processingMessage}
            />
          )}

        {renderedReports}

        {/* Onboarding turns are conversational setup — no favorite/export/schedule toolbox */}
              {!isLoading && !hideActions && conv.isOnboarding !== true && (
          <div
            className={clsx(
              "flex gap-2 lg:gap-3 mt-4 sm:ml-8",
              {
                "sm:ml-0": conv.date !== undefined,
              }
            )}
          >
            {conv.date === undefined && (
              <button
                onClick={onFavoriteClick}
                data-tooltip-id="tooltipActions"
                data-tooltip-content={"Add to favorites"}
                data-tooltip-place="top"
                data-tooltip-delay-show="300"
              >
                <svg
                  title="Star it"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.7282 2.98029C12.9568 1.65575 11.0432 1.65575 10.2718 2.98029L8.12486 6.66632L3.9558 7.56912C2.45769 7.89353 1.86639 9.71338 2.88769 10.8564L5.72989 14.0373L5.30018 18.2813C5.14578 19.8063 6.69383 20.931 8.09651 20.3129L12 18.5928L15.9035 20.3129C17.3062 20.931 18.8542 19.8063 18.6998 18.2813L18.2701 14.0373L21.1123 10.8564C22.1336 9.71338 21.5423 7.89353 20.0442 7.56912L15.8751 6.66632L13.7282 2.98029Z"
                    stroke={isFavorite ? "#1595DF" : "#303C54"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill={isFavorite ? "#1595DF" : "none"}
                  />
                </svg>
              </button>
            )}

            <button
              onClick={onCopyClick}
              data-tooltip-id="tooltipActions"
              data-tooltip-content="Copy"
              data-tooltip-place="top"
              data-tooltip-delay-show="300"
            >
              <img src={copy} alt="copy" />
            </button>

            <button
              onClick={() => onLikeClick(true)}
              data-tooltip-id="tooltipActions"
              data-tooltip-content={"Good response"}
              data-tooltip-place="top"
              data-tooltip-delay-show="300"
            >
              <img src={like} alt="like" />
            </button>

            <button
              onClick={() => onLikeClick(false)}
              data-tooltip-id="tooltipActions"
              data-tooltip-content={"Bad response"}
              data-tooltip-place="top"
              data-tooltip-delay-show="300"
            >
              <img src={dislike} alt="dislike" />
            </button>

            <button
              onClick={showCommentModal}
              data-tooltip-id="tooltipActions"
              data-tooltip-content={"Add a Comment"}
              data-tooltip-place="top"
              data-tooltip-delay-show="300"
            >
              <img src={comment} alt="comment" />
            </button>

            <button
              onClick={exportPdf}
              data-tooltip-id="tooltipActions"
              data-tooltip-content={"Export to PDF"}
              data-tooltip-place="top"
              data-tooltip-delay-show="300"
            >
              <img src={pdf} alt="pdf" />
            </button>

            {!loadingExcel && (
              <button
                onClick={exportExcel}
                data-tooltip-id="tooltipActions"
                data-tooltip-content={"Export to Excel"}
                data-tooltip-place="top"
                data-tooltip-delay-show="300"
              >
                <img src={xls} alt="xls" />
              </button>
            )}

            {loadingExcel && (
              <button
                onClick={exportExcel}
                data-tooltip-id="tooltipActions"
                data-tooltip-content={"Generating your Excel file..."}
                data-tooltip-place="top"
                data-tooltip-delay-show="300"
              >
                <img
                  src={icon}
                  alt="loader"
                  className="animate-spin-infinite"
                />
              </button>
            )}

            {conv.date === undefined && (
              <button
                onClick={onScheduleClick}
                disabled={scheduleDisabled}
                className={scheduleDisabled ? "opacity-40 cursor-not-allowed" : ""}
                data-tooltip-id="tooltipActions"
                data-tooltip-content={scheduleDisabled ? "Ask a question first to schedule it" : "Schedule it"}
                data-tooltip-place="top"
                data-tooltip-delay-show="300"
              >
                <img src={schedule} alt="schedule" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Response, (prevProps, nextProps) => {
  return (
    prevProps.conv === nextProps.conv &&
    prevProps.isLoading === nextProps.isLoading &&
    prevProps.loadingExcel === nextProps.loadingExcel &&
    prevProps.favorites === nextProps.favorites &&
    prevProps.processingMessage === nextProps.processingMessage &&
    prevProps.charts === nextProps.charts &&
    prevProps.tables === nextProps.tables &&
    prevProps.threadId === nextProps.threadId &&
    prevProps.isLastItem === nextProps.isLastItem &&
    prevProps.scheduleDisabled === nextProps.scheduleDisabled &&
    prevProps.children === nextProps.children
  );
});